import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoIsotipo } from '../components/Logo';
import { useAuth } from '../contexts/AuthContext';

export default function Splash() {
    const navigate = useNavigate();
    const { user, config } = useAuth();

    useEffect(() => {
        const t = setTimeout(() => {
            if (user && user.email_verified) {
                navigate(user.family_id ? '/home' : '/setup-family', { replace: true });
            } else {
                navigate('/intro', { replace: true });
            }
        }, 1800);
        return () => clearTimeout(t);
    }, [user, navigate]);

    return (
        <div
            className="fixed inset-0 flex flex-col items-center justify-center text-white"
            style={{
                background: 'linear-gradient(180deg, #5B5FDB 0%, #4346A3 100%)',
            }}
            data-testid="splash-screen"
        >
            <div className="pulse-soft flex flex-col items-center">
                <LogoIsotipo size={220} className="drop-shadow-2xl" />
            </div>
            <div className="absolute bottom-10 text-sm text-white/70 font-medium">
                {config?.app_version ? `2026 — 4everSync v${config.app_version}` : 'Cargando...'}
            </div>
        </div>
    );
}
